import styled from 'styled-components';
import {
  Pane,
} from 'evergreen-ui';
import fonts from '../../../config/fonts.json';
import colors from '../../../config/colors.json';

export const Container = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    > * {
        font-family: ${fonts.poppins};
    }
    .rounded-pill {
      outline: 0;
      background-color: #ffffff !important;

      &:focus {
        opacity: 1;
        background-color: #ffffff !important;
      }

      &:hover {
        opacity: 0.8;
        background-color: #ffffff !important;
      }
    }
`;

export const StyledPane = styled(Pane)`
  padding: 10px;

  .react-calendar {
    width: 350px;
    max-width: 100%;
    border: 0;
    background: ${colors.light};
    font-family: ${fonts.poppins};
  }
  .react-calendar__navigation__label {
    font-size: 15px;
    text-transform: capitalize;
  }
  .react-calendar button {
    margin: 0;
    border: 0;
    outline: none;
  }
  .react-calendar button:enabled:hover {
    cursor: pointer;
  }
  .react-calendar__navigation {
    height: 44px;
    margin-bottom: 1em;
  }
  .react-calendar__navigation button {
    min-width: 44px;
    background: inherit;

    svg {
      fill: ${colors.lightBlue};
      width: 20px;
      height: 20px;
    }
  }
  .react-calendar__navigation button:enabled:hover,
  .react-calendar__navigation button:enabled:focus {
    background-color: inherit;

    svg {
      opacity: 0.8;
    }
  }
  .react-calendar__navigation button[disabled] {
    background-color: inherit;

    svg {
      fill: ${colors.lightGrey2};
    }
  }
  .react-calendar__month-view__weekdays {
    text-align: center;
    text-transform: uppercase;
    font-weight: bold;
    font-size: 0.75em;
  }
  .react-calendar__month-view__weekdays__weekday {
    padding: 0.3em;
    font-size: 11px;
    text-decoration: none;

    abbr {
      text-decoration: none;
    }
  }
  .react-calendar__month-view__weekNumbers {
    font-weight: bold;
  }
  .react-calendar__month-view__weekNumbers .react-calendar__tile {
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 0.75em;
    padding: calc(0.75em / 0.75) calc(0.5em / 0.75);
  }
  .react-calendar__month-view__days__day--weekend {
    color: inherit;
  }
  .react-calendar__tile:disabled {
    background-color: ${colors.light};
    color: ${colors.lightGrey3};
  }
  .react-calendar__tile:enabled:hover,
  .react-calendar__tile:enabled:focus {
    background-color: inherit;
  }
  .react-calendar__tile--now {
    background-color: inherit;
  }
  .react-calendar__tile--now:enabled:hover,
  .react-calendar__tile--now:enabled:focus {
    background-color: inherit;
  }
  .react-calendar__tile--hasActive {
    background: ${colors.lightBlue};
    color: ${colors.light};
  }
  .react-calendar__tile--hasActive:enabled:hover,
  .react-calendar__tile--hasActive:enabled:focus {
    background: ${colors.lightBlue};
    color: ${colors.light};
  }
  .react-calendar__tile--active {
    background: ${colors.lightBlue};
    color: ${colors.light};
  }
  .react-calendar__tile--active:enabled:hover,
  .react-calendar__tile--active:enabled:focus {
    background: ${colors.lightBlue};
    color: ${colors.light};
  }
  .react-calendar--selectRange .react-calendar__tile--hover {
    background-color: ${colors.light};
    color: ${colors.light};
  }
`;

export const ButtonStyled = styled.button`
  font-family: ${fonts.poppins};
  border: none;
`;

export const IconStyled = styled.svg`
  color: ${colors.tiffany};
`;

export const CalendarStyled = styled.div`
  font-family: ${fonts.poppins};
`;

export const InputGroup = styled.div`
  position: relative;
  > label {
      position: absolute;
      z-index: 3;
      transform: translate(11px, -5px);
      font-size: 8px;
      margin-bottom: 0;
      padding: 0 2px;
      background-color: ${colors.light};
  }
`;
